import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { DialogStyles } from "./Dialog.styles";
import { DialogProps } from '.';

const DialogView = ({ open, handleClose, title, children, autoHeight, fullwidth, footer, asModel, isFooter, onSaveClick }: DialogProps) => {
	const classes = DialogStyles();

	return (
		<div className={classes.dialog}>
			<Dialog
				open={open}
				onClose={(event, reason) => {
					if (reason === 'backdropClick' && !asModel && handleClose) {
						handleClose(event, reason);
					}
				}}
				classes={{
					paper: classes.dialogPaper,
					paperScrollPaper: classes.dialogpaperScrollPaper,
					paperScrollBody: classes.dialogPaperScrollBody,
				}}
			>
				<DialogTitle disableTypography={false} classes={{ root: classes.dialogroot }}>
					<div className={classes.dialogTitle}>
						{title}
					</div>
				</DialogTitle>
				<DialogContent classes={{ root: fullwidth ? classes.dialogFull : classes.dialogCnt }}>
					<div className={!autoHeight ? classes.modalHeight : ""}>
						{children}
					</div>
				</DialogContent>
				{!isFooter &&
					<DialogActions classes={{ root: classes.dialogActions }}>
						{footer ? footer :
							<div>
								{onSaveClick && <Button onClick={onSaveClick} color="primary" variant="outlined" className='b-transparent'>
									{"SAVE"}
								</Button>}
								<Button onClick={handleClose} color="primary" variant="outlined" className='b-transparent'>
									{"CLOSE"}
								</Button>
							</div>
						}
					</DialogActions>
				}
			</Dialog>
		</div>
	);
}

export default DialogView